var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseLargeNoColor = function SvgCloseLargeNoColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.442 5.558a.625.625 0 0 1 0 .884L12.884 12l5.558 5.558a.625.625 0 1 1-.884.884L12 12.884l-5.558 5.558a.625.625 0 1 1-.884-.884L11.116 12 5.558 6.442a.625.625 0 1 1 .884-.884L12 11.116l5.558-5.558a.625.625 0 0 1 .884 0Z"
  })));
};
export default SvgCloseLargeNoColor;